import React from "react";
import MaterialIcon from "../../../components/MaterialIcon";
import { Card, Skeleton } from "./CockpitPrimitives";

function Kpi({ label, value, tone, icon, onClick, loading, selected }) {
  // Switched on: the pill turns into a tick, so the state reads without colour too.
  return (
    <Card
      className={`cockpit-kpi${onClick ? " cockpit-kpi--clickable" : ""}${selected ? " cockpit-kpi--active" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      aria-pressed={onClick ? !!selected : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => (e.key === "Enter" || e.key === " " ? (e.preventDefault(), onClick()) : null) : undefined}
    >
      <div className="cockpit-kpi-top">
        <span className="cockpit-kpi-label">{label}</span>
        <span className={`cockpit-kpi-pill cockpit-kpi-pill--${tone}`}>
          <MaterialIcon icon={selected ? "check" : icon} size={16} color="currentColor" weight={selected ? 600 : 400} />
        </span>
      </div>
      {loading ? (
        <Skeleton height={30} width={48} style={{ margin: "10px 0 6px" }} />
      ) : (
        <div className={`cockpit-kpi-value cockpit-kpi-value--${tone}`}>{value}</div>
      )}
    </Card>
  );
}

/**
 * Fristen & Aufgaben / Termine — the two headers of the task list beside the
 * daily report, and the filters for it: each tile switches its group on or
 * off (`groups`: the keys switched on, "tasks" / "appointment").
 */
export default function CockpitKpis({
  strings,
  tasks = 0,
  appointments = 0,
  loading,
  bookmarksLoading,
  groups = [],
  onToggleGroup,
}) {
  return (
    <section className="cockpit-kpis">
      <Kpi
        label={strings.cockpit_kpi_deadlines_tasks || "Fristen & Aufgaben"}
        value={tasks || 0}
        tone="accent"
        icon="list_alt_check"
        loading={loading || bookmarksLoading}
        selected={groups.includes("tasks")}
        onClick={onToggleGroup ? () => onToggleGroup("tasks") : null}
      />
      <Kpi
        label={strings.cockpit_kpi_appointments || "Termine"}
        value={appointments || 0}
        tone="slate"
        icon="calendar_month"
        loading={bookmarksLoading}
        selected={groups.includes("appointment")}
        onClick={onToggleGroup ? () => onToggleGroup("appointment") : null}
      />
    </section>
  );
}
